import "./bootstrap";
import { createApp, h, DefineComponent } from "vue";
import { createInertiaApp } from "@inertiajs/vue3";
import { createBootstrap } from "@omnitend/dashboard-for-laravel";

const appName = import.meta.env.VITE_APP_NAME || "AstroAdmin Cloud";

createInertiaApp({
  title: (title) => `${title} - ${appName}`,
  resolve: (name) => {
    const pages = import.meta.glob<DefineComponent>("./Pages/**/*.vue", {
      eager: true,
    });
    return pages[`./Pages/${name}.vue`];
  },
  setup({ el, App, props, plugin }) {
    createApp({ render: () => h(App, props) })
      .use(plugin)
      .use(createBootstrap())
      .mount(el);
  },
  progress: {
    color: "#4B5563",
  },
});
